<template>
  <div>
    <h1>Líneas de Flete</h1>
    <List :items="freightlines" :columns="columns" />
  </div>
</template>

<script>
import List from "@/components/gotrading/common/List.vue";
import { wencesApi } from "@/api/wencesApi";

export default {
  name: "FreightLinesPage",
  components: { List },
  data() {
    return {
      freightlines: [],
      columns: [
        { key: "name", label: "Nombre" },
        { key: "ports", label: "Puertos" },
        { key: "shippingLine", label: "Naviera" },
        { key: "forwarder", label: "Forwarder" },
        { key: "typeOfContainer", label: "Tipo de Contenedor" },
        { key: "currency", label: "Moneda" },
        { key: "price", label: "Precio" },
        { key: "transitTime", label: "Tiempo de Tránsito" },
        { key: "comment", label: "Comentario" },
      ],
    };
  },
  async mounted() {
    try {
      const response = await wencesApi.get("/api/gotrading/freight-lines");
      this.freightlines = response.data;
    } catch (error) {
      console.error("Error al obtener líneas de flete:", error);
    }
  },
};
</script>
